//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useState, useEffect, useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { Grid, makeStyles } from '@material-ui/core';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../../common/definitionHelper';
import { LayoutContext } from '../../../common/contexts';
//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {},

        aboutUsProfileContainer: {
            padding: 10,
            background: 'white',
            borderRadius: 10,
        },
        aboutUsContent: {
            padding: '0px 20px',
            overflowY: 'scroll',
            overflowX: 'hidden',
            height: 630,
            [theme.breakpoints.down('md')]: { height: '700px' },
            [theme.breakpoints.down('sm')]: { height: '570px' },

            '&::-webkit-scrollbar-track': {
                borderRadius: '10px',
                background: 'none',
            },
            '&::-webkit-scrollbar': {
                width: '8px',
                backgroundColor: '#F5F5F5',
            },
            '&::-webkit-scrollbar-thumb': {
                borderRadius: '10px',
                backgroundColor: 'rgba(0,0,0,0.2)',
            },
        },
        AboutUsProfileText: { fontSize: 16, fontWeight: 400 },
        sidebarHeading: {
            fontWeight: 'bold',
            fontSize: 18,
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 15,
            cursor: 'pointer',
            borderLeft: '4px solid rgba(255, 255, 255, 1)',
            '&:hover': { background: 'rgba(0, 0, 0, 0.03)', borderRadius: 3, borderLeft: '4px solid #1D8A8B' },
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes } = params;

    const defns = {
        aboutUsProfileContainer: { item: true, xl: 7, lg: 7, md: 11, sm: 11, xs: 11 },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const Employers = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;
    const layoutContext = useContext(LayoutContext);
    const { scrollToPageTop } = layoutContext;
    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    const [OpenDropdown, setOpenDropdown] = useState(false);
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        scrollToPageTop();
    }, [scrollToPageTop]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, setOpenDropdown, OpenDropdown });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Grid {...defns.aboutUsProfileContainer}>
            <div {...defns.aboutUsContent}>
                <div>
                    <h3>Employers</h3>
                </div>
                <div>
                    <p {...defns.AboutUsProfileText}>
                        Aliquam porta nisl dolor, molestie pellentesque elit molestie in. Morbi metus neque, elementum ullamcorper hendrerit eget, tincidunt et nisi. Sed magna
                        nunc, consequat vel aliquam vitae, porta ac mi. Integer commodo sapien lacus, nec interdum nisi vehicula aliquam. Aliquam enim lorem, laoreet ut egestas
                        quis, rutrum sed lectus. Duis et purus in dolor bibendum egestas vel vitae urna. Vestibulum dictum semper laoreet. Nulla augue tellus, aliquam mollis quam
                        eget, maximus iaculis sem. Praesent semper ex tortor, in rhoncus arcu sollicitudin ut. Donec magna lorem, efficitur quis fringilla sed, imperdiet sed risus.
                        Nam accumsan, elit sit amet pretium commodo, turpis augue molestie eros, quis maximus diam ex eget libero. Aliquam erat volutpat. Integer interdum arcu
                        nisi.
                        <br />
                        <br />
                        Cras venenatis lorem in molestie pulvinar. Donec a tortor et magna suscipit consectetur. Sed mi lacus, vehicula id ex nec, vulputate pretium urna. Aenean
                        accumsan facilisis ornare. Aenean porttitor augue at erat aliquam, quis mattis nunc egestas. Morbi malesuada lorem tortor, sed aliquam ante laoreet et.
                        Nulla facilisi. Nulla nisl velit, blandit vel sagittis et, venenatis et leo. Mauris nec metus pretium, hendrerit lectus in, iaculis diam. Fusce massa odio,
                        lacinia id leo at, eleifend egestas nibh. Etiam placerat magna sit amet scelerisque pulvinar. Quisque tempor ex nulla. Nullam non aliquam mauris, nec semper
                        velit. Duis aliquam fermentum sem quis fermentum.
                        <br />
                        <br />
                        Nunc at nunc vitae sem tempor vestibulum. Sed commodo a tortor placerat lacinia. Mauris placerat tempor nibh, lobortis imperdiet mauris egestas nec. Quisque
                        tincidunt ex non lacus finibus euismod. Praesent congue turpis a pulvinar varius. Etiam tempor sapien in viverra tincidunt. Donec vel lacus ultricies,
                        rhoncus odio sit amet, gravida magna. Curabitur posuere lacus id diam porta pulvinar.
                        <br />
                        <br />
                        Nunc at nunc vitae sem tempor vestibulum. Sed commodo a tortor placerat lacinia. Mauris placerat tempor nibh, lobortis imperdiet mauris egestas nec. Quisque
                        tincidunt ex non lacus finibus euismod. Praesent congue turpis a pulvinar varius. Etiam tempor sapien in viverra tincidunt. Donec vel lacus ultricies,
                        rhoncus odio sit amet, gravida magna. Curabitur posuere lacus id diam porta pulvinar.
                        <br />
                        <br />
                        Nunc at nunc vitae sem tempor vestibulum. Sed commodo a tortor placerat lacinia. Mauris placerat tempor nibh, lobortis imperdiet mauris egestas nec. Quisque
                        tincidunt ex non lacus finibus euismod. Praesent congue turpis a pulvinar varius. Etiam tempor sapien in viverra tincidunt. Donec vel lacus ultricies,
                        rhoncus odio sit amet, gravida magna. Curabitur posuere lacus id diam porta pulvinar.
                        <br />
                        <br />
                        Nunc at nunc vitae sem tempor vestibulum. Sed commodo a tortor placerat lacinia. Mauris placerat tempor nibh, lobortis imperdiet mauris egestas nec. Quisque
                        tincidunt ex non lacus finibus euismod. Praesent congue turpis a pulvinar varius. Etiam tempor sapien in viverra tincidunt. Donec vel lacus ultricies,
                        rhoncus odio sit amet, gravida magna. Curabitur posuere lacus id diam porta pulvinar.
                    </p>
                </div>
            </div>
        </Grid>
    );
};

export default Employers;
